import { AxiosInstance } from 'axios'
import { NpsPostPayloadDto } from '@/modules/nps/api/nps-post-payload-dto.interface'
import { CONSULTATION_LIST_ENDPOINT } from '@/modules/consultations/endpoint'
import { ConsultationListGetResponseDto, ConsultationsParams } from '@/modules/consultations'

export class MSConsultationsClient {
  client: AxiosInstance

  constructor(client: AxiosInstance) {
    this.client = client
  }

  createNps(data: NpsPostPayloadDto) {
    return this.client.post(`/api/nps`, data)
  }

  listConsultations(params: ConsultationsParams) {
    return this.client.get<ConsultationListGetResponseDto>(CONSULTATION_LIST_ENDPOINT, { params })
  }
}

export default MSConsultationsClient
